import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { FormApiValidationService } from './form-api-validation.service';

interface FormApiBinderPayload {
  children?: { [key: string]: string[] };
  global?: string[];
  responseMessage?: string;
  responseDetails?: string;
}

@Component({
  selector: 'app-form-api-validation-binder',
  templateUrl: './form-api-validation-binder.component.html',
  styleUrls: ['./form-api-validation-binder.component.scss']
})
export class FormApiValidationBinderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() formGroup: FormGroup;
  @Input() payload: FormApiBinderPayload | null;

  displayGlobalMessages: string[] = [];
  fieldErrorRows: { path: string; messageKey: string }[] = [];
  showResponseDetails = false;

  private clearSubs: Subscription[] = [];
  private wired = false;
  private responseDetailsTimer: any = null;

  constructor(private formApiValidation: FormApiValidationService) {}

  ngOnInit() {
    this.wireIfNeeded();
    this.apply();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup'] && this.formGroup && !this.wired) {
      this.wireIfNeeded();
    }
    if (changes['payload'] || changes['formGroup']) {
      this.apply();
    }
  }

  ngOnDestroy() {
    this.clearResponseDetailsTimer();
    this.formApiValidation.unsubscribeAll(this.clearSubs);
    this.wired = false;
  }

  private wireIfNeeded(): void {
    if (!this.formGroup || this.wired) {
      return;
    }
    this.clearSubs = this.formApiValidation.attachClearApiValidationOnValueChange(this.formGroup);
    this.wired = true;
  }

  private apply(): void {
    if (!this.formGroup) {
      this.displayGlobalMessages = [];
      this.fieldErrorRows = [];
      return;
    }
    this.displayGlobalMessages = this.formApiValidation.syncFormApiErrors(this.formGroup, this.payload);
    this.fieldErrorRows = this.buildFieldErrorRows();
    this.refreshResponseDetailsVisibility();
  }

  private refreshResponseDetailsVisibility(): void {
    this.clearResponseDetailsTimer();
    this.showResponseDetails = !!(this.payload && this.payload.responseDetails);
    if (this.showResponseDetails) {
      this.responseDetailsTimer = setTimeout(() => {
        this.showResponseDetails = false;
      }, 5000);
    }
  }

  private clearResponseDetailsTimer(): void {
    if (this.responseDetailsTimer) {
      clearTimeout(this.responseDetailsTimer);
      this.responseDetailsTimer = null;
    }
  }

  private buildFieldErrorRows(): { path: string; messageKey: string }[] {
    const rows: { path: string; messageKey: string }[] = [];
    if (!this.payload || !this.payload.children) {
      return rows;
    }
    Object.keys(this.payload.children).forEach((path) => {
      const msgs = this.payload.children[path];
      if (!msgs || !msgs.length) {
        return;
      }
      rows.push({ path: path, messageKey: msgs.join(' ') });
    });
    return rows;
  }

  showBanner(): boolean {
    if (!this.payload) {
      return false;
    }
    return !!(
      this.payload.responseMessage ||
      this.showResponseDetails ||
      this.displayGlobalMessages.length ||
      this.fieldErrorRows.length
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/forms/form-api-validation-binder.component.ts